<template>
    <div class="all-height">
        <el-main class="all-height">
            <div class="operation-bar">
                <h1>发货提醒</h1>
                <div class="operation-bar-right">
                    <div class="input-box" style="width: 180px">
                        <i></i>
                        <input type="text" v-model="saleOrderNo" placeholder="销售订单号"/>
                    </div>
                    <div class="input-box" style="width: 120px">
                        <i></i>
                        <input type="text" v-model="saleOrderRowNo" placeholder="销售订单行项目"/>
                    </div>
                    <div class="input-box" style="width: 180px">
                        <i></i>
                        <input type="text" v-model="mtrlName" placeholder="请输入物料名称"/>
                    </div>
                    <div class="input-box" style="width: 180px">
                        <i></i>
                        <input type="text" v-model="purchaseName" placeholder="请输入采购方"/>
                    </div>
                    <div class="input-box" style="width: 180px">
                        <i class="el-icon-search" @click="query"></i>
                        <input type="text" v-model="orderNo" placeholder="请输入订单编号"/>
                    </div>
                    <a href="javascript:void(0)" @click="makeSend">制单</a>
                </div>
            </div>
            <div class="table-box">
                <el-table ref="tb" @select-all="selectAll" @select="select" @row-click = "rowClick" :highlight-current-row="true" :data="dataList" height="calc(100% - 55px)"
                          :header-cell-style="{background:'#4885CA', color: 'white'}">
                    <el-table-column  width="50" type="selection" align="center" header-align="center" :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column property="orderNo" width="110" label="订单编号" align="center" header-align="center" :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column property="rowNo" width="80" label="行项目号" align="center" header-align="center" :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column property="sapSaleOrderNo" width="110" label="销售订单号" align="center" header-align="center" :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column property="sapSaleOrderRowNo" width="150" label="销售行项目" align="center" header-align="center" :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <span>{{scope.row.sapSaleOrderRowNo === '0'?'':scope.row.sapSaleOrderRowNo}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column width="130" label="物料编号" align="center" header-align="center" :show-overflow-tooltip="true">
                        <template slot-scope="scope">
                            <span>{{scope.row.sapMtrlCode.substr(-10,10)}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column property="sapMtrlName" width="200" label="物料名称" align="center" header-align="center"  :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column property="compName" label="采购方" width="180" align="center" header-align="center" :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column property="fkDhDate" width="120" label="确认到货日期" align="center" header-align="center">
                        <template slot-scope="scope">
                            {{dateFormat(scope.row.fkDhDate)}}
                        </template>
                    </el-table-column>
                    <el-table-column property="expectDate" width="100" label="交货日期" align="center" header-align="center">
                        <template slot-scope="scope">
                            {{dateFormat(scope.row.expectDate)}}
                        </template>
                    </el-table-column>

                    <el-table-column width="100" label="订单数量" align="center" header-align="center">
                        <template slot-scope="scope">
                            <span style="color: green">{{scope.row.qty}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column  width="100" label="待发数量" align="center" header-align="center">
                        <template slot-scope="scope">
                            <span style="color: red">{{scope.row.qty-scope.row.expectDqty}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column property="uom" width="80" label="计量单位" align="center" header-align="center">
                    </el-table-column>
                    <el-table-column property="price" width="80" label="单价" align="center" header-align="center">
                    </el-table-column>
                    <el-table-column property="sapTaxCode" width="70" label="税码" align="center" header-align="center">
                    </el-table-column>
                    <el-table-column property="vendorRemark" width="150" label="沟通备注" align="center" header-align="center" :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column property="ownerRemark"  label="采购方备注" align="center"  :show-overflow-tooltip='true' header-align="center">
                    </el-table-column>
                </el-table>
                <div class="table-page">
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="page.current"
                            :page-sizes="page.pageSizes"
                            :page-size="page.pageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="page.total">
                    </el-pagination>
                </div>
            </div>
        </el-main>
        <el-dialog
                :title="sendDiaLog.title"
                :visible.sync="sendDiaLog.isShow"
                width="30%"
                @close="closeDialog"
        >
            <el-form ref="sendform" :model="form" :rules="rules" label-width="100px">
                <el-form-item label="采购方:" prop="toComp">
                    <el-select v-model="form.toComp" placeholder="请选择所属公司" style="display:block;">
                        <el-option
                                v-for="item in compList"
                                :key="item.to_comp"
                                :label="item.sap_to_comp_name"
                                :value="item.to_comp">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="预计发货日期:" prop="sendDate">
                    <el-date-picker
                            style="width: 100%"
                            v-model="form.sendDate"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="请输入预计发货日期">
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="预计到货日期:" prop="expectDate">
                    <el-date-picker
                            style="width: 100%"
                            v-model="form.expectDate"
                            type="date"
                            value-format="yyyy-MM-dd"
                            placeholder="请输入预计发货日期">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeDialog">取 消</el-button>
                <el-button type="primary" @click="submitForm">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import dayjs from 'dayjs'
    export default {
        name: 'sendRemind',
        data() {
            return {
                currentRow: null,
                orderNo: '',
                saleOrderNo: '',
                saleOrderRowNo: '',
                mtrlName: '',
                purchaseName: '',
                dataList: [],
                sendDiaLog: {
                    title: '',
                    isShow: false
                },
                compList: [],
                form: {
                    toComp: '',
                    orderNo: '',
                    sendDate: '',
                    expectDate: ''
                },
                page: {
                    current: 1,
                    pageSizes: [20,20,30,50],
                    pageSize: 20,
                    total: 0
                },
                rules: {
                    toComp: [
                        { required: true, message: '请选择采购方'}
                    ],
                }
            }
        },
        methods: {
            selectAll(selection) {
                this.$refs.tb.clearSelection();
                this.currentRow = null;
            },
            select(selection, row) {
                this.$refs.tb.clearSelection();
                this.$refs.tb.toggleRowSelection(row);
                this.currentRow = row;
            },
            rowClick(row) {
                this.$refs.tb.clearSelection();
                this.$refs.tb.toggleRowSelection(row);
                this.currentRow = row;
            },
            makeSend() {
                // if(this.currentRow != null){
                //     this.form.orderNo = this.currentRow.orderNo;
                //     this.sendDiaLog.title = '创建发货单'
                //     this.sendDiaLog.isShow = true;
                // }else{
                //     this.$message.warning('请选择一行数据')
                // }
                this.$store.dispatch('send/send/getCompList').then((res)=>{
                    if(res.code === '200') {
                        this.compList = res.data;
                    }else{
                        this.$message.error(res.data?res.data : res.message);
                    }
                })
                this.sendDiaLog.title = '创建发货单'
                this.sendDiaLog.isShow = true;
            },
            closeDialog() {
                this.sendDiaLog.isShow = false;
            },
            submitForm() {
                this.$refs.sendform.validate((valid,err) => {
                    if (!valid) {
                        return false;
                    }

                    this.$store.dispatch('send/send/saveSend', this.form).then((res)=>{
                        if(res.code === '200') {
                            this.$message.success("保存成功");
                            this.sendDiaLog.isShow = false;
                            this.$router.push({
                                path: '/send/send',
                                query: {
                                    orderNo: this.form.orderNo
                                }
                            });
                        }else{
                            this.$message.error(res.data?res.data : res.message);
                        }
                    })

                });

            },
            handleSizeChange(pageSize) {
                this.page.pageSize = pageSize;
                this.loadDataList();
            },
            handleCurrentChange(current) {
                this.page.current = current;
                this.loadDataList();
            },
            loadDataList() {
                let params = {
                    current: this.page.current,
                    size: this.page.pageSize,
                    orderNo: this.orderNo,
                    sapSaleOrderNo: this.saleOrderNo,
                    sapSaleOrderRowNo: this.saleOrderRowNo,
                    sapMtrlName: this.mtrlName,
                    compName: this.purchaseName
                };
                this.$store.dispatch('order/order/preSendOrderDetailSummary',params).then((res) => {
                    if(res.code === '200') {
                        this.page.current = res.data.current;
                        this.page.total = res.data.total;
                        this.dataList = res.data.records;
                    }else{
                        this.$message.error(res.data?res.data : res.message);
                    }
                });
            },

            query() {
                this.page.current = 1;
                this.loadDataList();
            },
            dateFormat(val) {
                if (val) {
                    return dayjs(val).format('YYYY-MM-DD');
                } else {
                    return '';
                }
            }
        },
        created() {
            this.loadDataList();
        }
    };
</script>
<style scoped>
    .table-box {
        position: relative;
        margin-top: 5px;
        background-color: white;
        height: calc(100% - 35px);
        width: 100%;
    }
    .table-page {
        width: 100%;
        text-align: center;
        position: absolute;
        bottom: 10px;
    }
</style>
